import React from 'react'
import { Button, ButtonGroup } from '@livingdesign/react';
import ModalLD3 from '../../../../../common/Modal/ModalLD3';

export const QA_ID_PREFIX = 'SavedRecipientsDeleteModal';

function SavedRecipientsDeleteModal({isOpen, onClose, title, subTitle, secondaryAction, primaryAction, isDeleteInProgress}) {

  return (
    <ModalLD3
        isOpen={isOpen}
        onClose={onClose}
        title={title}
        actions={
            <div data-testid={`${QA_ID_PREFIX}-actions`}>
            <ButtonGroup data-testid={`${QA_ID_PREFIX}-button-group`}>
                <Button disabled={isDeleteInProgress} variant="tertiary" onClick={secondaryAction} data-testid={`${QA_ID_PREFIX}-cancel-button`}>
                Cancel
                </Button>
                <Button disabled={isDeleteInProgress} variant="destructive" onClick={primaryAction} data-testid={`${QA_ID_PREFIX}-delete-button`}>
                Delete Filter
                </Button>
            </ButtonGroup>
            </div>
        }
        size={"medium"}
        data-testid={`${QA_ID_PREFIX}-modal`}
    >{subTitle}</ModalLD3>
  )
}

export default SavedRecipientsDeleteModal;